import { Component, Inject, OnInit, inject } from "@angular/core";
import { AWSLambda } from "../../../AWSLambda.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Auth } from "aws-amplify";
import { AuthService } from "../../../services/auth.service";
import { detectEnv } from "src/app/services/Enviroment";
import { MatDialog } from "@angular/material/dialog";
import { TUI_IS_MOBILE } from "@taiga-ui/cdk";
import { ConfirmDialogComponent } from "../../../components/modals/confirm-dialog.component";
import { TranslateService } from "@ngx-translate/core";
import { ConditionTypesService } from "../../../services/condition-types.service";
import { BoRolesCheckService } from 'src/app/components/rolesCheck/bo-roles-check.service';


@Component({
  selector: 'app-edit-items',
  templateUrl: './edit-items.component.html',
  styles: [
    `
      .loading-mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(
          0,
          0,
          0,
          0.5
        ); /* semi-transparent black background */
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999; /* Ensure it's on top of other content */
      }
      app-button button{
        padding: 2px 4px!important;
      }
      .table-header{
        border-bottom: 1px solid #cf0e10;
      }
    `,
  ],
})
export class EditItemsComponent implements OnInit {
  lambda = inject(AWSLambda);

  /** Servicio de autenticación */
  authService = inject(AuthService);

  /** Servicio de tipos de condición */
  conditionTypesService = inject(ConditionTypesService);

  /** Controlador de modales */
  dialog = inject(MatDialog);

  /** Entorno actual detectado ('dev', 'prod', etc.) */
  protected currentEnv = detectEnv();

  structure: string = ""
  canAccess = false;

  editMode: boolean = false;
  showSpinnerItems: boolean = true;
  filteredCounts = {
    items: 0
  };
  items: any[] = [];
  currentItem: any = {};
  filterFields: any[] = [];
  rolesCheck = inject(BoRolesCheckService);
  public partner:string =""

  constructor(
    private route: ActivatedRoute,
    @Inject(TUI_IS_MOBILE) readonly isMobile: boolean,
    private translate: TranslateService



  ) {
    const snapshot = this.route.snapshot;

    // Obtener `type` desde params o ruta
    this.structure = snapshot.params['type'];
  }

  /**
 * Método de ciclo de vida `ngOnInit` que se ejecuta al inicializar el componente.
 *
 * - Valida que el entorno actual (`currentEnv`) esté permitido según lo almacenado en `localStorage`.
 * - Si el entorno no está permitido, cierra la sesión del usuario y lanza un error.
 * - Si es permitido, recarga la sesión autenticada a través de `authService.refresh()`.
 * - Dependiendo de la estructura (`promo`, `send_money`, `partner`), realiza una petición a Lambda para cargar los ítems disponibles.
 * - Configura los campos de filtro (`filterFields`) que se mostrarán en la vista.
 * - Maneja errores y actualiza el estado `items` y `showSpinnerItems`.
 *
 * @async
 * @returns {Promise<void>}
 */

  async ngOnInit() {
    try {
      const allowedEnvStr = localStorage.getItem('allowedEnvs') || '';
      const allowedEnvs = allowedEnvStr.split(',').map(e => e.trim().toLowerCase());

      const env = this.currentEnv; // 'dev' | 'prod'

      if (!allowedEnvs.includes(env)) {
        await Auth.signOut();
        throw new Error(`No tienes permiso para entrar a este entorno ${env.toUpperCase()}`);
      }
      this.canAccess = await this.rolesCheck.checkAccess();
      if (!this.canAccess) {
        return;
      }
      this.partner = this.route.snapshot.queryParamMap.get('code') ?? '';

      await this.authService.refresh();

      /**
       *  🔑 Suscripción para leer los cambios en los parametros y recargar la pagina
       * **/
      this.route.params.subscribe(async params => {
        this.showSpinnerItems = true; // spinner mientras cambia

        this.structure =params['type'] || 'promo';

        switch (this.structure) {
          case "promo":
          case "send_money":
          case "partner":
            const items_data = await this.lambda.getLambdaFunction(
              'lambda',
              '/tools',
              {
                queryStringParameters: {
                  method: 'getItems',
                  item_type: this.structure
                }
              }
            );

            this.filterFields = [
              {
                key: 'id',
                type: 'text',
                label: this.translate.instant('ID'),
                searchKeys: ['id']
              }
            ];
            this.items = items_data.items;
            break;
        }

        // filtros personalizados
        switch (this.structure) {
          case "promo":
            this.filterFields.push();
            break;

          case "send_money":
            this.filterFields.push({
              key: 'allowFreeCard',
              type: 'select',
              label: this.translate.instant('LISTS.SEND_MONEY.ALLOWFREECARD'),
              options: [
                { key: -1, value: this.translate.instant('COMMON.ALL') },
                { key: true, value: this.translate.instant('TRUE') },
                { key: false, value: this.translate.instant('FALSE') },
              ]
            });
            this.filterFields.push({
              key: 'allowFreeDB',
              type: 'select',
              label: this.translate.instant('LISTS.SEND_MONEY.ALLOWFREEDB'),
              options: [
                { key: -1, value: this.translate.instant('COMMON.ALL') },
                { key: true, value: this.translate.instant('TRUE') },
                { key: false, value: this.translate.instant('FALSE') },
              ]
            });
            break;

          case "partner":
            this.filterFields.splice(0, 1);
            this.filterFields.push({
              key: 'partnerCode',
              type: 'text',
              label: "partner",
              defaultValue: this.partner
              });
            // Usar el servicio centralizado para obtener las opciones
            const conditionTypeOptions = await this.conditionTypesService.getConditionTypeOptions();

            this.filterFields.push({
              key: 'conditionType',
              type: 'select',
              label: 'Aplica a',
              defaultValue: -1,
              options: conditionTypeOptions,
              customFilter: (item: any, filterValue: any) => {
                if (filterValue === -1 || filterValue === null || filterValue === undefined) {
                  return true;
                }
                return item[filterValue] === true;
              }
            });
            break;
        }

        this.showSpinnerItems = false;
      });

    } catch (error) {
      console.error('getting structure from data:', error);
      this.items = [];
      this.authService.logout();
    }
  }


  /**
   * Método para invocar desde componente padre al hijo para la creación de un
   * nuevo registro.
   * Opcional. Depende de las acciones que se quieran realizar sobre el registro
   * @param item registro de la lista
   */
  newItemList() {
    console.log('Nuevo elemento');

    // Para partners, inicializar con el partnerCode de la URL
    if (this.structure === 'partner' && this.partner) {
      this.currentItem = {
        partnerCode: this.partner
      };
    } else {
      this.currentItem = {};
    }

    this.toggleMostrarBloque(true);
  }

  toggleMostrarBloque(valor: boolean) {
    this.editMode = valor;
  }

  //////////////////////////////////////////////////////////
  //////                                              //////
  ////// INICIO DE MÉTODOS NECESARIOS PARA LAS LISTAS //////
  //////                                              //////
  //////////////////////////////////////////////////////////

  /**
   * Método para invocar desde componente padre al hijo para la acción sobre click del elemento
   * @param item registro de la lista
   */
  onItemClick(item: any) {
    console.log('Clicked item:', item);
  }

  /**
   * Método para invocar desde componente padre al hijo para el cambio en los filtros
   * @param filters valor de los filstros cambiados
   */
  onFiltersChanged(filters: any) {
    console.log('Filters updated:', filters);
  }

  /**
   * Método para invocar desde componente padre al hijo para la paginación
   * @param page número de página a mostrar
   */
  onPageChanged(page: number) {
    console.log('Page changed to:', page);
  }

  /**
   * Método para invocar desde componente padre al hijo para la edición del registro
   * Opcional. Depende de las acciones que se quieran realizar sobre el registro
   * @param item registro de la lista
   */
  editItemList(item: any) {
    console.log('Editando', item);
    this.currentItem = item;
    this.editMode = true;
  }

  /**
   * Método para invocar desde componente padre al hijo para el borrado del registro
   * Opcional. Depende de las acciones que se quieran realizar sobre el registro
   * @param item registro de la lista
   */
  async deleteItemList(item: any) {

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      minWidth: this.isMobile ? '95%' : '30%',
      panelClass: 'zendy-modal',
      data: item
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result === true) {
        this.showSpinnerItems = true;
        console.log('Eliminando', item);
        await this.lambda.getLambdaFunction(
          'lambda',
          '/tools',
          {
            queryStringParameters: {
              method: 'deleteItem',
              item_type: this.structure,
              item_id: item.id
            }
          }
        );
        window.location.reload();
      }
      this.showSpinnerItems = false;
    });

  }
  ///////////////////////////////////////////////////////
  //////                                           //////
  ////// FIN DE MÉTODOS NECESARIOS PARA LAS LISTAS //////
  //////                                           //////
  ///////////////////////////////////////////////////////

  getConditionTypeText(item: any): string {
    // Usar el campo appliesTo directamente
    if (item.appliesTo) {
      return this.conditionTypesService.getConditionTypeText(item.appliesTo);
    }

    return 'Sin definir';
  }

  getRangesText(item: any): string {
    // Usar el campo revenue directamente
    if (item.revenue && item.revenue.length > 0) {
      const ranges = item.revenue.map((range: any) => {
        // Formatear unit correctamente
        let unit_display = range.unit;
        if (range.unit === 'fixed' || range.unit === '') {
          unit_display = '€';
        }
        return `[${range.min}, ${range.max}): ${range.quantity}${unit_display}`;
      });
      return ranges.join('\n');
    }
    return 'Sin rangos';
  }

}
